"use client";

import { useRef, useState } from "react";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";

export function SplashScreen() {
    const containerRef = useRef<HTMLDivElement>(null);
    const textRef = useRef<HTMLParagraphElement>(null);
    const subTextRef = useRef<HTMLParagraphElement>(null);
    const [isComplete, setIsComplete] = useState(false);

    useGSAP(() => {
        const tl = gsap.timeline({
            onComplete: () => setIsComplete(true)
        });

        // Elements start invisible via CSS (opacity-0)
        // We animate elements TO visible
        tl.to(textRef.current, {
            y: 0,
            opacity: 1,
            duration: 1,
            ease: "power3.out",
            delay: 0.2
        })
            .to(subTextRef.current, {
                y: 0,
                opacity: 1,
                duration: 0.8,
                ease: "power3.out"
            }, "-=0.5")
            // Then animate whole container OUT
            .to(containerRef.current, {
                opacity: 0,
                duration: 0.8,
                ease: "power2.inOut",
                delay: 0.8
            })
            .set(containerRef.current, { display: "none" });

    }, { scope: containerRef });

    if (isComplete) return null;

    return (
        <div
            ref={containerRef}
            className="fixed inset-0 z-[100] bg-[#001746] flex flex-col items-center justify-center text-white"
        >
            <div className="text-center">
                <p ref={textRef} className="text-4xl md:text-6xl font-bold font-serif tracking-tight mb-4 opacity-0 translate-y-8">
                    <span className="text-white">CNS</span>
                </p>
                <p ref={subTextRef} className="text-blue-200 text-xs md:text-base uppercase italic tracking-[0.2em] opacity-0 translate-y-4">
                    Your Innovative Technology Partner
                </p>
            </div>
        </div>
    );
}
